import request from "@/utils/request";
import { start } from "nprogress";

// 员工管理--start
// 员工频率表--start
//查询table
export function adminEmployeefrequencyGET(params) {
  return request({
    url: "/admin/employee/frequency",
    method: "get",
    params: params,
  });
}
// 查询员工工作记录
export function adminEmployeeWorkLogListGET(params) {
  return request({
    url: "/admin/employee/workLog/list",
    method: "get",
    params: params,
  });
}
// 查询店铺配置
export function adminStoreConfigGET(params) {
  return request({
    url: "/admin/store/config",
    method: "get",
    params: params,
  });
}
// 更新店铺配置
export function adminStoreConfigPUT(params) {
  return request({
    url: `/admin/store/config/${params.id}`,
    method: "put",
    data: params,
  });
}
// 员工频率表--end
// 打卡记录--start
// 查询打卡列表
export function adminTimeRecordListGET(params) {
  return request({
    url: "/admin/time/record/list",
    method: "get",
    params: params,
  });
}
// 审批通过
export function adminTimeRecordAcceptPUT(params) {
  return request({
    url: `/admin/time/record/accept/${params.id}`,
    method: "put",
    data: params,
  });
}
// 审批驳回
export function adminTimeRecordOverRulePUT(params) {
  return request({
    url: `/admin/time/record/overrule/${params.id}`,
    method: "put",
    data: params,
  });
}
// 打卡记录--end
// 课时确认--start
// 查询B课时确认列表
export function adminSalaryLessonBConfirmGET(params) {
  return request({
    url: "/admin/salary/lesson/b/confirm",
    method: "get",
    params: params,
  });
}
// 添加或修改当日员工课时确认
export function adminSalaryLessonBConfirmPost(data) {
  return request({
    url: "/admin/salary/lesson/b/confirm",
    method: "post",
    data: data,
  });
}
// 课时确认--end
// 薪资表--start
// 查询员工薪资统计
export function adminSalaryListGET(params) {
  return request({
    url: "/admin/salary/list",
    method: "get",
    params: params,
  });
}
// 设置员工薪资配置
export function adminSalarySettingPost(data) {
  return request({
    url: "/admin/salary/setting",
    method: "post",
    data: data,
  });
}

// 批量修改薪资
export function updateAdminSalaryPost(data) {
  return request({
    url: "/admin/salary/batchSetting",
    method: "post",
    data: data,
  });
}

// 员工薪资封账
export function stopAdminSalarySealPUT(data) {
  return request({
    url: "/admin/salary/seal",
    method: "put",
    data: data,
  });
}

// 员工薪资导出
export function exportAdminSalaryGET(data) {
  return request({
    url: "/admin/salary/export",
    method: "post",
    data: data,
    responseType: 'blob',
  });
}

// 查询封账状态
export function adminSalarySealStatusGET(params) {
  return request({
    url: "/admin/salary/seal/status",
    method: "get",
    params: params,
  });
}

// 薪资表--end
// 工作安排--start
export function adminJobPlanListGET(params) {
  return request({
    url: "/admin/jobPlan/list",
    method: "get",
    params: params,
  });
}
// 查询工作安排待指定用户列表
export function adminJobPlanPlanUsersGET(params) {
  return request({
    url: "/admin/jobPlan/plan/users",
    method: "get",
    params: params,
  });
}
// 查询门店下正常员工列表
export function adminJobPlanPlanWorksGET(params) {
  return request({
    url: "/admin/jobPlan/plan/workers",
    method: "get",
    params: params,
  });
}
// 新增工作安排
export function adminJobPlanPost(data) {
  return request({
    url: "/admin/jobPlan",
    method: "post",
    data: data,
  });
}
// 查询工作安排
export function adminJobPlanGET(params) {
  return request({
    url: "/admin/jobPlan",
    method: "get",
    params: params,
  });
}
// 查询工作安排执行记录
export function adminJobPlanRecordGET(params) {
  return request({
    url: "/admin/jobPlan/record",
    method: "get",
    params: params,
  });
}
// 修改工作安排
export function adminJobPlanPUT(data) {
  return request({
    url: "/admin/jobPlan",
    method: "put",
    data: data,
  });
}
// 工作安排--end
// 员工管理--end



// WEBPACK FOOTER //
// ./src/api/vtwonewcontent.js